<template lang="html">
  <div class="special-detail" v-if="html_show">
    <p class="yulan-p" v-if="$route.name == 'MPreviewSpecialDetail'">此为临时链接，仅用于专题预览，将在短期内失效，请勿转发！</p>
    <div id="header-contain">
      <div class="banner">
        <img :src="base_info.logo_path | logo_show">
      </div>
      <div class="desc">
        <p>{{base_info.title | dealTitle}}</p>
        <p>{{base_info.summary | dealTitle}}</p>
        <div class="topic" v-if="news_topic_list.length != 0">
          <img :src="$store.state.static_img_url+'mobile/pic/kuaixun.png'">
          <div class="swiper">
            <swiper :options="swiperOption" ref="mySwiper">
              <swiper-slide v-for="(slide, index) in news_topic_list" :key="index" :data-id="slide.id">{{slide.title}}</swiper-slide>
            </swiper>
          </div>
          <p @click="goNewsList">更多</p>
        </div>
      </div>
      <div class="divider"></div>
    </div>
    <div class="list list-item" :class="{'other':idx != 0}" :id="'module'+i.module_id" :data-id="i.module_id" v-for="(i, idx) in module_list" :key="i.module_id" v-if="i.pid == null && (is_vip || base_info.is_buy || (!base_info.is_buy && i.lock_up == '0'))">
      <div class="module-p" :ref="'module'+i.module_id">
        <p>{{i.name}}</p>
      </div>
      <!-- 编辑语 -->
      <SpecialEditComment :list="module_all['module_text_content'+i.module_id]"></SpecialEditComment>
      <SpecialTimeLine :list="module_all['module_time_line'+i.module_id]" :uid="base_info.uid" v-if="module_all['module_time_line'+i.module_id].length != 0 && base_info.uid != temp_uid" :key="i.module_id"></SpecialTimeLine>
      <TempTimeLine :list="module_all['module_time_line'+i.module_id]" :uid="base_info.uid" v-if="module_all['module_time_line'+i.module_id].length != 0 && base_info.uid == temp_uid" :key="i.module_id"></TempTimeLine>
      <SpecialMap :list="module_all['module_map'+i.module_id]"></SpecialMap>
      <div v-for="item, index in module_all['module_tct'+i.module_id]" :key="'module_tct' + i.module_id + '_' + item.id" v-if="item.status == 1 || (item.status == 0 && $route.name == 'MPreviewSpecialDetail')">
        <OrgContrast :cItem="item" :uid="base_info.uid" v-if="item.mode_type == 0" :entityNtag="entity_ntag"></OrgContrast>
        <PointTime :cItem="item" :uid="base_info.uid" v-if="item.mode_type == 1" :annotationTag="annotation_tag" :address="address"></PointTime>
        <PointTag :cItem="item" :uid="base_info.uid" v-if="item.mode_type == 2" :annotationTag="annotation_tag" :address="address"></PointTag>
        <CompanySankey :cItem="item" :uid="base_info.uid" v-if="item.mode_type == 3" :entityNtag="entity_ntag" :tctBusinessNature="tct_business_nature"></CompanySankey>
      </div>
      <SpecialTable :list="module_all['module_table'+i.module_id]" :uid="base_info.uid" :tempuid="temp_uid"></SpecialTable>
      <div>
        <div v-for="(j, index) in module_all['res_list'+i.module_id]" :key="j.publish_time + index">
          <!-- 有图片的文章 -->
          <div class="with-pic" v-if="j.content_type == '0'" @click="goDetail(j)">
            <div class="base">
              <div class="left">
                <img :src="j.logo_path | logo_show">
              </div>
              <div class="right">
                <p class="one">{{j.title | dealTitle}}</p>
                <div class="two">
                  <span v-if="j.create_user_name">{{j.create_user_name.name}}</span><span>{{j.publish_time | timeTrans}}</span>
                </div>
              </div>
            </div>
            <SpecialComment :list="module_all['insight_theme_content'+i.module_id]" :rowid="j.module_theme_id"></SpecialComment>
          </div>
          <!-- 专题(新旧都有) -->
          <div class="special-item" v-if="j.content_type == '3' || j.content_type == '2'" @click="goDetail(j)">
            <div class="base">
              <div class="left">
                <img :src="j.share_logo_path | logo_show">
                <p>专题</p>
              </div>
              <div class="right">
                <p class="one">{{j.title | dealTitle}}</p>
                <p class="two">{{j.summary | dealTitle}}</p>
              </div>
            </div>
            <SpecialComment :list="module_all['insight_theme_content'+i.module_id]" :rowid="j.module_theme_id"></SpecialComment>
          </div>
          <!-- 快讯 -->
          <div class="topic-item" v-if="j.content_type == '1'">
            <div>
              <p class="title" @click="open(i.module_id,j.id)">{{j.title | dealTitle}}<span class="open" v-if="showOpen(i.module_id,j.id)"><i class="iconfont">&#xe648;</i></span></p>
              <p class="time">{{j.publish_time | time_standard}}</p>
              <div class="summary" v-html="j.summary" :class="{'summary-open': !showOpen(i.module_id,j.id)}">
              </div>
              <SpecialComment class="detail-comment" :class="{'detail-comment-open': !showOpen(i.module_id,j.id)}" :list="module_all['insight_theme_content'+i.module_id]" :rowid="j.module_theme_id"></SpecialComment>
              <div class="img-list" v-for="(img, index) in j.file_arr" v-if="showOpen(i.module_id,j.id) ? index<1:index<j.file_arr.length" :key="img.id">
                <img :preview="j.module_theme_id+img.path" :src="img.path | logo_show">
              </div>
              <div class="bottom" v-if="!showOpen(i.module_id,j.id)">
                <p @click="open(i.module_id,j.id)">收起 <i class="iconfont">&#xe63b;</i> </p>
                <div @click="goTopicShare(j.uid)" class="right">
                  <span>分享至</span>
                  <div>
                    <i class="iconfont">&#xe641;</i>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 政策 -->
          <div class="policy-item" v-if="j.content_type == '5'" @click="goDetail(j)">
            <p>
              <span>政策</span>
              <span>{{j.title}}</span>
              <i class="iconfont">&#xe63b;</i>
            </p>
            <p>发文时间：{{j.publish_time | timeTrans}}<span v-if="j.address_id">{{j.address_id | addressPeggingPrintf(address, '-')}}</span><span v-if="j.publish_org">{{j.publish_org}}</span></p>
            <SpecialComment :list="module_all['insight_theme_content'+i.module_id]" :rowid="j.module_theme_id"></SpecialComment>
          </div>
        </div>
        <!-- 翻页 -->
        <div v-show="module_all['is_show_more_button'+i.module_id]" class="more-button" :class="{ 'loading': module_all['button_loading'+i.module_id] }" @click="changeModulePage(i.module_id)">
          <span>{{module_all['button_loading'+i.module_id] ? '正在加载中...':'加载更多'}}</span>
        </div>
      </div>
      <!-- 如果有子列表 -->
      <div class="list-child list-item" :class="{'first':childIndex(i.module_id, c.module_id) == '01'}" :id="'module'+c.module_id" :data-id="c.module_id" v-for="(c, index) in module_list" :key="c.module_id" v-if="c.pid == i.module_id && (is_vip || base_info.is_buy || (!base_info.is_buy && i.lock_up == '0'))">
        <div class="module-second-p" :ref="'module'+c.module_id">
          <div>{{childIndex(i.module_id, c.module_id)}}</div>
          <p>{{c.name}}</p>
        </div>
        <!-- 编辑语 -->
        <SpecialEditComment :list="module_all['module_text_content'+c.module_id]"></SpecialEditComment>
        <SpecialTimeLine :list="module_all['module_time_line'+c.module_id]" v-if="module_all['module_time_line'+c.module_id].length != 0 && base_info.uid != temp_uid" :key="c.module_id"></SpecialTimeLine>
        <TempTimeLine :list="module_all['module_time_line'+c.module_id]" v-if="module_all['module_time_line'+c.module_id].length != 0 && base_info.uid == temp_uid" :key="c.module_id"></TempTimeLine>
        <SpecialMap :list="module_all['module_map'+c.module_id]"></SpecialMap>
        <div v-for="item, index in module_all['module_tct'+c.module_id]" :key="'module_tct' + c.module_id + '_' + item.id" v-if="item.status == 1 || (item.status == 0 && $route.name == 'MPreviewSpecialDetail')">
          <OrgContrast :cItem="item" :uid="base_info.uid" v-if="item.mode_type == 0" :entityNtag="entity_ntag"></OrgContrast>
          <PointTime :cItem="item" :uid="base_info.uid" v-if="item.mode_type == 1" :annotationTag="annotation_tag" :address="address"></PointTime>
          <PointTag :cItem="item" :uid="base_info.uid" v-if="item.mode_type == 2" :annotationTag="annotation_tag" :address="address"></PointTag>
          <CompanySankey :cItem="item" :uid="base_info.uid" v-if="item.mode_type == 3" :entityNtag="entity_ntag" :tctBusinessNature="tct_business_nature"></CompanySankey>
        </div>
        <SpecialTable :list="module_all['module_table'+c.module_id]" :uid="base_info.uid" :tempuid="temp_uid"></SpecialTable>
        <div v-for="(j, index) in module_all['res_list'+c.module_id]" :key="j.publish_time + index">
          <!-- 有图片的文章 -->
          <div class="with-pic" v-if="j.content_type == '0'" @click="goDetail(j)">
            <div class="base">
              <div class="left">
                <img :src="j.logo_path | logo_show">
              </div>
              <div class="right">
                <p class="one">{{j.title | dealTitle}}</p>
                <div class="two">
                  <span v-if="j.create_user_name">{{j.create_user_name.name}}</span><span>{{j.publish_time | timeTrans}}</span>
                </div>
              </div>
            </div>
            <SpecialComment :list="module_all['insight_theme_content'+c.module_id]" :rowid="j.module_theme_id"></SpecialComment>
          </div>
          <!-- 专题 -->
          <div class="special-item" v-if="j.content_type == '3' || j.content_type == '2'" @click="goDetail(j)">
            <div class="base">
              <div class="left">
                <img :src="j.share_logo_path | logo_show">
                <p>专题</p>
              </div>
              <div class="right">
                <p class="one">{{j.title | dealTitle}}</p>
                <p class="two">{{j.summary | dealTitle}}</p>
              </div>
            </div>
            <SpecialComment :list="module_all['insight_theme_content'+c.module_id]" :rowid="j.module_theme_id"></SpecialComment>
          </div>
          <!-- 快讯 -->
          <div class="topic-item" v-if="j.content_type == '1'">
            <div>
              <p class="title" @click="open(c.module_id,j.id)">{{j.title | dealTitle}}<span class="open" v-if="showOpen(c.module_id,j.id)"><i class="iconfont">&#xe648;</i></span></p>
              <p class="time">{{j.publish_time | time_standard}}</p>
              <div class="summary" v-html="j.summary" :class="{'summary-open': !showOpen(c.module_id,j.id)}">
              </div>
              <SpecialComment class="detail-comment" :class="{'detail-comment-open': !showOpen(c.module_id,j.id)}" :list="module_all['insight_theme_content'+c.module_id]" :rowid="j.module_theme_id"></SpecialComment>
              <div class="img-list" v-for="(img, index) in j.file_arr" v-if="showOpen(c.module_id,j.id) ? index<1:index<j.file_arr.length" :key="img.id">
                <img :preview="j.module_theme_id+img.path" :src="img.path | logo_show">
              </div>
              <div class="bottom" v-if="!showOpen(c.module_id,j.id)">
                <p @click="open(c.module_id,j.id)">收起 <i class="iconfont">&#xe63b;</i> </p>
                <div @click="goTopicShare(j.uid)" class="right">
                  <span>分享至</span>
                  <div>
                    <i class="iconfont">&#xe641;</i>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 政策 -->
          <div class="policy-item" v-if="j.content_type == '5'" @click="goDetail(j)">
            <p>
              <span>政策</span>
              <span>{{j.title}}</span>
              <i class="iconfont">&#xe63b;</i>
            </p>
            <p>发文时间：{{j.publish_time | timeTrans}}<span v-if="j.address_id">{{j.address_id | addressPeggingPrintf(address, '-')}}</span><span v-if="j.publish_org">{{j.publish_org}}</span></p>
            <SpecialComment :list="module_all['insight_theme_content'+c.module_id]" :rowid="j.module_theme_id"></SpecialComment>
          </div>
        </div>
        <!-- 翻页 -->
        <div v-show="module_all['is_show_more_button'+c.module_id]" class="more-button" :class="{ 'loading': module_all['button_loading'+c.module_id] }" @click="changeModulePage(c.module_id)">
          <span>{{module_all['button_loading'+c.module_id] ? '正在加载中...':'加载更多'}}</span>
        </div>
      </div>
    </div>
    <div class="list-item" v-if="!is_vip && parseFloat(base_info.price) > 0 && !base_info.is_buy" @click="goBuy('theme_type_id',base_info.type_arr[0],'13', $route.fullPath)" style="position: relative">
      <img class="vip-mask" :src="$store.state.static_img_url + 'mobile/pic/theme/vip-mask.png'">
      <p class="vip-p"> <span>￥{{getTypePrice(base_info.type_arr[0])}}</span>/年
        <br />
        此内容需付费，单篇专题付费后
        <br />
        附赠解锁互联网医院所有专题
      </p>
    </div>
    <div class="editor" v-else>
      <span>（数字资讯部·编辑: {{base_info.create_user_name}}）</span>
    </div>
    <div class="theme-last">
      <span v-for="item,index in theme_types">{{item | dealNeed(theme_type)}}</span>
    </div>
    <div class="relevant_theme">
      <p>猜您喜欢</p>
      <div class="list">
        <div class="li" v-for="item,index in relevant_theme" :key="index" @click="goRelevantTheme(item.uid)">
          <img :src="item.share_logo_path | logo_show" />
          <div class="t"><p>{{item.title}}</p></div>
        </div>
      </div>
      <div class="more"><span @click="moreTheme">查看更多<i class="iconfont">&#xe647;</i></span></div>
    </div>
    <!-- 固定目录icon -->
    <div class="menu-icon" @click="menu_show=true">
      <i class="iconfont">&#xe6cf;</i><span>目录</span>
    </div>

    <!-- 目录抽屉 -->
    <div class="menu" :class="{'open': menu_show}">
      <div class="one">
        <span>
          目录
          <img src="~/mobile/pic/border.png" />
        </span>
      </div>
      <ul class="fa-ul">
        <li v-for="i in module_list" v-if="i.pid == null" :key="i.module_id" @click="selectAnchor(i.module_id)">
          <p :class="{'selected':menu_selected == i.module_id}">{{i.name}} <img v-if="!is_vip && i.lock_up == '1'" :src="$store.state.static_img_url+'mobile/pic/theme/'+(base_info.is_buy == 1?'open':'close')+'-lock.png'"></p>
          <ul>
            <li v-for="j in module_list" v-if="j.pid == i.module_id" :key="j.module_id" @click.stop="selectAnchor(j.module_id)">
              <p :class="{'selected':menu_selected == j.module_id}"><span class="dot"></span>{{j.name}}<img v-if="!is_vip && i.lock_up == '1'" :src="$store.state.static_img_url+'mobile/pic/theme/'+(base_info.is_buy == 1?'open':'close')+'-lock.png'"></p>
            </li>
          </ul>
        </li>
      </ul>
    </div>

    <!-- 页面蒙层 -->
    <div :class="{'mask': menu_show}" @click="menu_show=false"></div>
  </div>
  <Loading v-else="!html_show"></Loading>
</template>

<script>
import SpecialComment from './SpecialComment.vue'
import SpecialEditComment from './SpecialEditComment.vue'
import SpecialTimeLine from './SpecialTimeLine.vue'
import TempTimeLine from './TempTimeLine.vue'
import SpecialMap from './SpecialMap.vue'
import SpecialTable from './SpecialTable.vue'
import OrgContrast from './OrgContrast'
import PointTime from './PointTime'
import PointTag from './PointTag'
import CompanySankey from './CompanySankey'
import { is_open_mixin } from 'mobile/js/is_open_mixin'
import { user_mixin } from 'mobile/js/user_mixin'
import { share } from 'mobile/js/wx_share'
import { themeInfo, themeModule, themeNewsTopic, addPuv, wxShare, previewTheme, themeModulContentAll, getMeta, createThemeTypeOrder, getRelevantTheme } from '../service'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import Loading from '@/views/Mobile/components/loading.vue'
export default {
  inject: ['goBuy'],
  mixins: [is_open_mixin, user_mixin],
  data() {
    let _this = this
    return {
      fixed: false,
      base_info: {},
      module_list: [],
      news_topic_list:[],
      module_all: {}, // 各类数据集合

      swiperOption: {
        autoplay: true,
        speed: 300,
        direction: 'vertical',
        loop: true,
        on: {
          click(e,h){
            _czc.push(['_trackEvent', '手机端专题详情页', '快讯详情点击（' + e.innerHTML + '）'])
            _this.$store.commit('updateTopicNewestId', e.target.dataset.id)
            _this.$router.push({name: 'MSpecialNewsList', params: { uid: _this.base_info.id }})
          }
        }
      },

      html_show: false,
      menu_show: false,
      menu_selected: '',
      is_selected: false,

      module_item_offset_list: [], // 每个模块高度的数组集合
      dom_list: [],
      address: [],
      theme_type: [],
      entity_ntag: [],
      round: [],
      annotation_tag: [],
      relevant_theme: [],
      theme_types: [],
      tct_business_nature: [],
      // temp_uid: 'f6ac2a3aa3a2d66aaedbf35845ffa076' // 测试
      temp_uid: '14ed09fbc414ca231221fa4fac4204b0' // 正式
    }
  },
  components: {
    SpecialComment,
    SpecialEditComment,
    SpecialTimeLine,
    TempTimeLine,
    SpecialMap,
    SpecialTable,
    OrgContrast,
    PointTime,
    PointTag,
    swiper,
    swiperSlide,
    Loading,
    CompanySankey
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper
    },
    req_url() {
      return this.$store.state.req_url
    },
    link_keyword() {
      var url = location.search
      var theRequest = new Object()
      if (url.indexOf("?") != -1) {
        var str = url.substr(1)
        var strs = str.split("&")
        for (var i = 0; i < strs.length; i++) {
          theRequest[strs[i].split("=")[0]] = unescape(strs[i].split("=")[1])
        }
      }
      return theRequest
    }
  },
  methods: {
    /**
     * 专题模块内容第一页
     * theme_id int 专题id
     * module_id array 专题模块数组
     */
    async getThemeModulContentAll(t_id, m_id) {
      let res = await themeModulContentAll({
        theme_id: t_id,
        module_id: m_id,
        is_preview: this.$route.name === 'MPreviewSpecialDetail' ? 1 : ''
      }, (error) => this.$Message.error('请求错误！'))
      if(res.status == 'success') {
        res.res.map((a) => {
          this['module_all']['module_text_content'+a.module_id] = [...this['module_all']['module_text_content'+a.module_id],...a.module_insight_content] // 编辑语
          this['module_all']['res_list'+a.module_id] = [...this['module_all']['res_list'+a.module_id],...a.content] // 普通内容
          this['module_all']['insight_theme_content'+a.module_id] = [...this['module_all']['insight_theme_content'+a.module_id],...a.insight_theme_content] // 评论
          this['module_all']['module_time_line'+a.module_id] = [...this['module_all']['module_time_line'+a.module_id],...a.module_time_line] // 时间轴
          this['module_all']['module_map'+a.module_id] = [...this['module_all']['module_map'+a.module_id],...a.module_map] // 图谱
          this['module_all']['module_table'+a.module_id] = [...this['module_all']['module_table'+a.module_id],...a.module_table] // 表格
          this['module_all']['module_tct'+a.module_id] = [...this['module_all']['module_tct'+a.module_id],...a.module_tct] // 表格
          if (a.content.length < 3) {
            this['module_all']['is_show_more_button'+a.module_id] = false
          }
          this['module_all']['button_loading'+a.module_id] = false
        })
        this.html_show = true
        this.$forceUpdate()
        this.$previewRefresh()
      } else {
        this.$Message.error(res.message)
      }
    },
    async getDetail() { // 获取基本信息
      let res = await themeInfo({theme_uid: this.$route.params.uid, user_key: this.$store.state.user_key},
      (error) => this.$Message.error('请求错误!'))
      if (res.status == 'success') {
        this.base_info = res.info[0]
        this.$store.commit('updateHtmlTitle', this.base_info.title)
        this.theme_types = res.info[0].type_arr
        this.getRelevantTheme(res.info[0].id, res.info[0].tag_arr, res.info[0].type_arr)
        this.module_list = res.module
        let m_list = []
        for(let i of res.module) {
          this['module_all']['page'+i.module_id] = 1
          this['module_all']['is_show_more_button'+i.module_id] = true
          this['module_all']['button_loading'+i.module_id] = false
          this['module_all']['module_text_content'+i.module_id] = []
          this['module_all']['res_list'+i.module_id] = []
          this['module_all']['insight_theme_content'+i.module_id] = []
          this['module_all']['module_time_line'+i.module_id] = []
          this['module_all']['module_map'+i.module_id] = []
          this['module_all']['module_tct'+i.module_id] = []
          this['module_all']['module_table'+i.module_id] = []
          m_list.push(i.module_id)
          // this.getModuleDetail(i.module_id)
        }
        if (!this.is_vip && parseFloat(this.base_info.price) > 0 && !this.base_info.is_buy) {
          m_list = res.module.filter(x => x.lock_up == '0').map(y => y.module_id)
          this.getThemeModulContentAll(this.base_info.id, m_list)
        } else {
          this.getThemeModulContentAll(this.base_info.id, m_list)
        }
        this.getNewsTopic()
        this.addPuv()
        this.themeShare()
      } else {
        this.$Message.error(res.message)
      }
    },
    /**
     * “猜你喜欢”列表
     */
    async getRelevantTheme(id, tag_arr, type_arr) {
      this.module_list = {}
      let res = await getRelevantTheme({
        id: id,
        type_arr: type_arr,
        tag_arr: tag_arr
      }, (error) => this.$Message.error('请求错误！'))
      if(res.status == 'success') {
        this.$set(this.$data, 'relevant_theme', res.res)
      } else {
        this.$Message.error(res.message)
      }
    },
    goRelevantTheme(uid) {
      this.$router.push({name: "MSpecialDetail", params: {uid: uid}})
    },
    moreTheme() {
      this.$router.push({name: "MSpecialList"})
    },
    async getNewsTopic(module_id) { // 获取快讯轮播
      let res = await themeNewsTopic({
        theme_id: this.base_info.id,
        page: 1
      }, (error) => this.$Message.error('请求错误!'))
      if (res.status == 'success') {
        this.news_topic_list = res.res
      } else {
        this.$Message.error(res.message)
      }
    },
    async getModuleDetail(module_id) { // 获取模块基本信息
      let res = await themeModule({
        theme_id: this.base_info.id,
        module_id: module_id,
        page: this['module_all']['page'+module_id]
      }, (error) => this.$Message.error('请求错误!'))
      if (res.status == 'success') {
        this['module_all']['module_text_content'+module_id] = [...this['module_all']['module_text_content'+module_id],...res.module_text_content]
        this['module_all']['res_list'+module_id] = [...this['module_all']['res_list'+module_id],...res.res]
        this['module_all']['insight_theme_content'+module_id] = [...this['module_all']['insight_theme_content'+module_id],...res.insight_theme_content]
        this['module_all']['module_time_line'+module_id] = [...this['module_all']['module_time_line'+module_id],...res.module_time_line]
        this['module_all']['module_map'+module_id] = [...this['module_all']['module_map'+module_id],...res.module_map] // 图谱
        this['module_all']['module_tct'+module_id] = [...this['module_all']['module_tct'+module_id],...res.module_map] // 图谱
        this['module_all']['module_table'+module_id] = [...this['module_all']['module_table'+module_id],...res.module_table] // 表格
        if (res.res.length < 3) {
          this['module_all']['is_show_more_button'+module_id] = false
        }
        this['module_all']['button_loading'+module_id] = false

        this.$forceUpdate()
        this.$previewRefresh()
      } else {
        this.$Message.error(res.message)
      }
    },
    async addPuv() {
      await addPuv({ url: window.location.protocol + '//' + window.location.host + '/mindex' +this.$route.fullPath, row_id: this.base_info.id})
    },
    async themeShare() {
      let res = await wxShare({"url":this.$store.state.req_url+"/mindex" + this.$route.fullPath},
        (error) => { this.$Message.error('请求错误!') }
      )
      share(res, {
        title: this.base_info.title,
        desc: this.base_info.summary,
        link: this.req_url + '/mindex' + this.$route.fullPath,
        imgUrl: this.$store.state.share_img_url + this.base_info.share_logo_path
      }, this, window.location.href)
    },
    changeModulePage(module_id) { // 翻页(延时函数等待dom渲染完成：不影响渲染时间，获取各版块儿的偏移量，nextTick方法不准确)
      this['module_all']['page'+module_id] = this['module_all']['page'+module_id] + 1
      this.getModuleDetail(module_id)
      setTimeout(() => {
        this.module_item_offset_list = []
        for(let i = 0;i<this.dom_list.length;i++) {
          jQuery(
            this.module_item_offset_list.push({
              id: $(this.dom_list[i]).attr('data-id'),
              offset: $(this.dom_list[i]).offset().top - 250
            })
          )
        }
      }, 2500)
    },
    goNewsList(which, slide) { // 点击更多，跳转快讯列表
      _czc.push(['_trackEvent', '手机端专题详情页', '快讯查看更多点击'])
      this.$router.push({name: 'MSpecialNewsList', params: { uid: this.base_info.id }})
    },
    goDetail(j) {
      let type = j.content_type + ''
      switch (type) {
        case '0': // 动脉网文章
          window.location.href = this.$store.state.index2_path + '/' + j.content_id;
          break;
        case '2': // 旧专题
          window.location.href = this.$store.state.index2_path + '/seriesD/' + j.content_id
          break;
        case '3': // 新专题
          if (navigator.userAgent.indexOf('iPhone') > 0) {
            this.$router.push({name: 'MSpecialDetail', params: { uid: j.content_uid, theme_id: j.content_id}})
          } else {
            this.$router.replace({name: 'MSpecialDetail', params: { uid: j.content_uid, theme_id: j.content_id}})
            location.reload()
          }
          break;
        case '5': // 政策
          this.$router.push({name: 'MPolicyDetail', params: { uid: j.content_uid}})
          break;
      }
    },
    selectAnchor(id) {
      this.menu_selected = id
      this.is_selected = true
      let to = 0
      for(let i = 0;i<this.dom_list.length;i++) {
        let current_id
        let has_other = false
        let has_first = false
        jQuery(has_other = $(this.dom_list[i]).hasClass('other'))
        jQuery(has_first = $(this.dom_list[i]).hasClass('first'))
        jQuery(current_id = $(this.dom_list[i]).attr('data-id'))
        if (has_other) {
          jQuery(to = $(this.dom_list[i]).offset().top - 40)
        } else if (has_first) {
          jQuery(to = $(this.dom_list[i]).offset().top - 70)
        } else {
          jQuery(to = $(this.dom_list[i]).offset().top - 50)
        }
        if (current_id == id) {
          break
        }
      }
      jQuery(
        $(window).scrollTop(to)
      )
    },
    hasChild(id) { // 是否有二级
      let arr = this.module_list.filter(item => item.pid == id)
      if (arr.length == 0) {
        return false
      } else {
        return true
      }
    },
    childIndex(f_id, c_id) { // 序号
      let arr = this.module_list.filter(item => item.pid == f_id).map(item => item.module_id)
      return '0' + (arr.indexOf(c_id)+ 1)
    },
    async getPreviewTheme(uid, sign, time) {
      let preview_params = {
        theme_uid: uid,
        sign: sign,
        timestamp: time
      }
      let res = await previewTheme(preview_params, (error) => this.$Message.error('请求错误！'))
      if (res.status == 'success') {
        this.base_info = res.res[0]
        this.module_list = res.module
        let m_list = []
        for(let i of res.module) {
          this['module_all']['page'+i.module_id] = 1
          this['module_all']['is_show_more_button'+i.module_id] = true
          this['module_all']['button_loading'+i.module_id] = false
          this['module_all']['module_text_content'+i.module_id] = []
          this['module_all']['res_list'+i.module_id] = []
          this['module_all']['insight_theme_content'+i.module_id] = []
          this['module_all']['module_time_line'+i.module_id] = []
          this['module_all']['module_map'+i.module_id] = []
          this['module_all']['module_tct'+i.module_id] = []
          this['module_all']['module_table'+i.module_id] = []
          // this.getModuleDetail(i.module_id)
          m_list.push(i.module_id)
        }
        this.getThemeModulContentAll(this.base_info.id, m_list)
        this.getNewsTopic()
        this.themeShare()
      } else {
        this.$Message.error(res.message)
      }
    },
    async getMeta() {
      let res = await getMeta({
        name: ['address', 'theme_type', 'entity_ntag', 'round', 'annotation_tag', 'tct_business_nature']
      })
      if (res.status == 'success') {
        this.address = res.meta.address
        this.theme_type = res.meta.theme_type
        this.entity_ntag = res.meta.entity_ntag
        this.round = res.meta.round
        this.annotation_tag = res.meta.annotation_tag
        this.tct_business_nature = res.meta.tct_business_nature
        if(this.$route.name === 'MSpecialDetail') {
          this.getDetail()
        } else {
          this.getPreviewTheme(this.link_keyword.theme_uid, this.link_keyword.sign, this.link_keyword.timestamp)
        }
      } else {
        this.$Message.error(res.message)
      }
    },
    getTypePrice(type_id) {
      if (type_id) {
        return this.theme_type.find(item => item.id == type_id).price
      } else {
        return 0
      }
    }
  },
  created() {
    this.getMeta()
  },
  updated() {
    let getOffsetList = () => {
      jQuery(
        this.dom_list = $('.list-item')
      )
      this.module_item_offset_list = []
      for(let i = 0;i<this.dom_list.length;i++) {
        jQuery(
          this.module_item_offset_list.push({
            id: $(this.dom_list[i]).attr('data-id'),
            offset: $(this.dom_list[i]).offset().top - 250
          })
        )
      }
      let all_finish = false
      for (var i = 0; i < this.module_item_offset_list.length; i++) {
        if (this.module_item_offset_list[i].offset) {
          if (this.module_item_offset_list.length == i+1) {
            all_finish = true
          } else {
            continue
          }
        } else {
          break
        }
      }
      if (all_finish) { // 全部dom都有
        let _this = this
        jQuery(
          $(window).scroll(function(e) {
            if (_this.is_selected) {
              _this.is_selected = false
              return
            }
            for(let i = 0;i<_this.module_item_offset_list.length;i++) {
              if ($(window).scrollTop() > _this.module_item_offset_list[i].offset) {
                _this.menu_selected = _this.module_item_offset_list[i].id
              }
            }
          })
        )
      } else { // 还有dom没生成
        getOffsetList()
      }
    }
    getOffsetList()
  }
}
</script>
<style lang="stylus" scoped>
.yulan-p
  background: #ffecdc;
  position: fixed;
  top: 1rem;
  left: 0;
  color: #FA5A00;
  padding: .2rem;
  z-index: 100;
ellipsis()
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
.special-detail
  // padding-bottom: .4rem;
  .banner
    position: relative;
    z-index: 9;
    img
      height: 3.2rem;
      width: 100%;
      display: block;
    .weixin
      width: .68rem;
      height: .68rem;
      background: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      position: absolute;
      top: .4rem;
      right: .4rem
      i
        color: rgb(46, 198, 107);
        font-size: .40rem
  .desc
    position: relative;
    padding: .5rem .4rem .32rem .4rem;
    background: #fff;
    // border: 1px solid #E9E9E9;
    z-index: 10;
    p:nth-child(1)
      font-size: .5rem;
      color: #333333;
      line-height: .64rem;
      font-weight: bold;
    p:nth-child(2)
      font-size: .32rem;
      color: #666666;
      line-height: .48rem;
      margin-top: .22rem
    .topic
      margin-top: .3rem;
      padding-top: .24rem;
      border-top: 1px solid #f3f3f3;
      display: flex;
      img
        width:.7rem;
        height: .23rem;
        display: block;
        margin-top: .1rem;
      div.swiper
        flex: 2;
        margin: 0 .2rem;
        height: .50rem;
        .swiper-container
          height: 100%;
          .swiper-slide
            font-weight: normal;
            color: #333333;
            font-size: .28rem;
            line-height: .48rem;
            height: .44rem;
            -webkit-line-clamp: 1;
            ellipsis()
      p
        font-size: .28rem;
        color: #FA5A00;
        line-height: .44rem;
  .divider
    height: .2rem;
    width: 100%;
    background: #F7F7F7;
  .list
    padding: .4rem .4rem;
    position: relative;
    // margin: 0 .4rem;
    .list-child+.list-child
      border-top: 1px solid #f3f3f3;
      margin-top: .4rem;
    .module-p
      display: flex;
      justify-content: center;
      p
        font-size: .44rem;
        color: #333333;
        font-weight: 600;
        text-align: center;
        display: inline-block;
        background-image: url(../../../../src/assets/mobile/pic/title_bg.png);
        padding: .2rem .6rem;
        background-size: 1.1rem .8rem;
        background-repeat: no-repeat;
        line-height: .54rem;
    .module-second-p
      display: flex;
      margin-top: .4rem;
      margin-bottom: .4rem;
      div
        width: .4rem;
        height: .4rem;
        background: url(../../../../src/assets/mobile/pic/two.png);
        background-repeat: no-repeat;
        background-size: 100% 100%;
        font-size: .24rem;
        color: #FFFFFF;
        font-weight: 600;
        line-height: .46rem;
        text-align: center;
      p
        font-size: .36rem;
        color: #333333;
        font-weight: 600;
        margin-left: .18rem;
        margin-top: .04rem
    .with-pic
      margin-top: .3rem;
      .base
        display: flex;
        .left
          width: 2rem;
          height: 1.44rem;
          img
            width: 100%;
            height: 100%;
            display: block;
        .right
          flex: 2;
          margin-left: .18rem;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: .04rem 0;
          .one
            font-size: .32rem;
            color: #333333;
            line-height: .48rem;
            font-weight: 600;
            -webkit-line-clamp: 2;
            height: .96rem;
            ellipsis()
          .two
            display: flex;
            justify-content: space-between;
            font-size: .24rem;
            color: #999999;
    .special-item
      margin-top: .3rem;
      .base
        display: flex;
        .left
          width: 2rem;
          height: 1.44rem;
          position: relative;
          img
            width: 100%;
            height: 100%;
            display: block;
          p
            position: absolute;
            top: 0;
            left: 0;
            padding: .08rem .16rem;
            color: #fff;
            background: linear-gradient(179deg, #ffa337 0%, #FA5A00 100%);
            font-size: .24rem;
        .right
          flex: 2;
          margin-left: .18rem;
          display: flex;
          flex-direction: column;
          padding: .04rem 0;
          .one
            font-size: .32rem;
            color: #333333;
            line-height: .48rem;
            font-weight: 600;
            -webkit-line-clamp: 2;
            max-height: .96rem;
            ellipsis()
          .two
            margin-top: .2rem;
            font-size: .24rem;
            color: #666;
            line-height: .32rem;
            -webkit-line-clamp: 2;
            height: .64rem;
            ellipsis()
    .topic-item
      margin-top: .4rem;
      .title
        font-size:.32rem;
        color: #333333;
        line-height: .48rem;
        font-weight:600;
      span.type+span.type:before
        content: ','
      span.open
        margin-left: .1rem;
        color: #FA5A00;
        font-weight:normal;
        i
          font-size: .24rem !important;
      .time
        margin: .1rem 0 .15rem 0;
        font-size: .24rem;
        color: #999;
      .img-list
        width: 100%;
        // height: 3.35rem;
        text-align: center;
        img
          max-width: 100%;
          max-height: 3.35rem;
          margin: 0 auto;
          display: block;
      .summary
        background: #F9F9F9;
        font-size: .28rem;
        color: #666666;
        line-height: .44rem;
        padding: 0;
        height: 0;
        overflow: hidden;
        // margin-bottom: .15rem;
        &.summary-open
          padding: .3rem;
          height: auto;
      .detail-comment
        height: 0;
        padding: 0;
        margin-top: 0;
        overflow: hidden;
        &.detail-comment-open
          height: auto;
          margin-top: 0.4rem;
          padding: 0.3rem;
          overflow: visible;
      .bottom
        margin-top: .34rem;
        display: flex;
        justify-content: space-between;
        p
          color: #FA5A00;
          font-size: .28rem;
          i
            font-size: .24rem;
            margin-left: .16rem;
        .right
          display: flex;
          span
            font-size: .24rem;
            color: #999999;
            margin-top: 0.02rem;
          div
            width: .68rem;
            height: .68rem;
            background: #fff;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 50%;
            border: 1px #eee solid;
            margin-top: -.17rem;
            margin-left: .2rem;
            i
              color: rgb(46, 198, 107);
              font-size: .40rem;
    .topic-item+.topic-item
      margin-top: .6rem;
    .policy-item
      margin-top: .3rem;
      p:nth-child(1)
        color: #333333;
        font-size: .32rem;
        font-weight: bold;
        line-height: .48rem;
        span:nth-child(2)
          &:before
            content: '|';
            color: #E9E9E9;
            margin: 0 .1rem;
            font-weight: normal;
        i
          color: #FA5A00;
          font-size: 0.24rem
          font-weight: normal;
          display: inline-block;
          transform: rotate(90deg) translate(-0.04rem,-0.08rem);
      p:nth-child(2)
        color: #999999;
        font-size: .24rem;
        margin: 0.1rem 0 0.15rem 0;
        height: .24rem;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        span:before
          content: '|';
          color: #E9E9E9;
          margin: 0 .2rem;
  .list+.list
    margin-top: .2rem;
    border-top: .2rem solid #f6f7fa;
  .more-button
    margin-top: .3rem;
    background: #FFFAF6;
    border-radius: .08rem;
    text-align: center;
    color: #FA5A00;
    font-size: .3rem;
    padding: .24rem 0;
  .vip-mask
    width: 100%;
  .vip-p
    font-size: .24rem;
    color: #333333;
    font-weight: bold;
    position: absolute;
    left: 50%;
    top: 39%;
    transform: translate(-50%);
    line-height: .32rem;
    text-align: center;
    span
      color: #FA5A00
  .editor
    height: .8rem;
    color: #999;
    font-size: .24rem;
    text-align: right;
    padding: .28rem .4rem;
    margin-top: .4rem3
  .theme-last
    padding: .28rem 0
    margin: 0 .4rem
    border-top: 1px solid #F3F3F3
    margin-bottom: -.2rem
    span
      background: #F9F9F9
      color: #666666
      font-size: .24rem
      padding: .08rem .16rem
      display: inline-block
      vertical-align: top
      margin-right: .2rem
      margin-bottom: .2rem
  .relevant_theme
    padding: .4rem 0
    border-top: .2rem solid #F6F7FA
    > p
      border-left: .12rem solid #FA5A00
      padding-left: .28rem
      font-size: .36rem
      font-weight: 800
      color: #333333
    .list
      display: grid
      grid-template-columns: calc(50% - .1rem) calc(50% - .1rem)
      grid-gap: .2rem
      .li
        position: relative
        height: 2rem
        img
          height: 2rem
          width: 100%
          position: absolute
          z-index: 1
        .t
          position: absolute
          height: .68rem
          bottom: .12rem
          z-index: 2
          padding: 0 .18rem
          p
            color: #FFFFFF
            font-weight: 600
            font-size: .24rem
            line-height: .34rem
            height: .68rem
            display: -webkit-box
            overflow: hidden
            text-overflow: ellipsis
            word-break: break-all
            -webkit-box-orient: vertical
            -webkit-line-clamp: 2
    .more
      text-align: center
      span
        font-size: .28rem
        color: #FA5A00
        i
          font-size: .28rem
          display: inline-block
          vertical-align: top
  .menu-icon
    position: fixed;
    right: 0;
    bottom: 1rem;
    background-image: linear-gradient(90deg, #FFBB49 0%, #FA5A00 100%);
    box-shadow: 0 2px 16px 0 rgba(250,100,0,0.30);
    border-radius: 100px 3px 3px 100px;
    padding: .24rem .2rem .24rem .28rem;
    color: #fff;
    font-size: .28rem;
    z-index: 11;
    i
      margin-right: .08rem;
      font-size: .28rem;
  .menu
    width: 4.4rem;
    height: 100%;
    transform: translate(4.4rem);
    position:fixed;
    top: 0;
    right: 0;
    z-index: 1003;
    background: #fff;
    transition: all .3s;
    &.open
      transform: translate(0);
    .one
      padding: 0 .6rem;
      border-bottom: 1px solid #E9E9E9;
      font-size: .36rem;
      color: #333333;
      font-weight: 600;
      height: 1rem;
      span
        display: inline-block;
        padding: .32rem 0 .32rem;
        position: relative;
        img
          position: absolute;
          bottom: 0;
          left: 0;
          height: .06rem;
          width: 100%;
          display: block;
    .fa-ul
      padding: .6rem;
      line-height: .36rem;
      overflow-y: scroll;
      height: calc(100% - 1rem)
      >li+li
        margin-top: .6rem;
      >li
        img
          width: .32rem;
          height: .32rem;
          vertical-align: sub;
        >p
          font-size: .28rem;
          color: #333333;
          font-weight: 600;
          &.selected
            color: #FA5A00;
        ul
          li
            margin-top: .5rem;
            p
              font-size: .28rem;
              color: #666666;
              display: flex;
              align-items: center;
              &.selected
                color: #FA5A00;
                font-weight: 600;
              .dot
                background: #D8D8D8;
                width: .1rem;
                height: .1rem;
                display: inline-block;
                margin-right: .2rem;
                border-radius: 50%;
  .mask
    position:fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,0.50);
    z-index: 1002;
</style>
